module.exports = __webpack_public_path__ + "aaee58d7adc528c6c6b2e2eeacf381c8.png";